import { render, staticRenderFns } from "./ReconciliationView.vue?vue&type=template&id=12c306b6&"
import script from "./ReconciliationView.vue?vue&type=script&lang=ts&"
export * from "./ReconciliationView.vue?vue&type=script&lang=ts&"
import style0 from "./ReconciliationView.vue?vue&type=style&index=0&id=12c306b6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports